import { useEffect, RefObject } from 'react';
let openCount = 0;
let previousOverflow = '';

/** Shared scroll locking and focus restoration, including nested native dialogs. */
export function useModalDialog(ref: RefObject<HTMLDialogElement | null>, open: boolean) {
  useEffect(() => {
    if (!open || !ref.current) return;
    const dialog = ref.current;
    const previous = document.activeElement as HTMLElement | null;
    if (openCount++ === 0) previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      if (--openCount === 0) document.body.style.overflow = previousOverflow;
      if (previous?.isConnected && !previous.closest('[inert]')) previous.focus({ preventScroll: true });
    };
  }, [open, ref]);
}
